import cn from "classnames";
import React, { Component } from "react";

class Transition extends Component {
    state = {
        mounted: false,
    };

    componentDidMount() {
        setTimeout(() => this.setState({ mounted: true }), 50);
    }

    componentWillUnmount() {
        this.setState({ mounted: false });
    }

    render() {
        const { children, dir, match, location, wrapper } = this.props;
        const cname = cn({
            [`page-col page-col--${dir}`]: true,
            "page-col--hideable": match && location && match.url !== location.pathname,
            [wrapper]: !!wrapper,
            mounted: this.state.mounted,
        });
        return <div className={cname}>{children}</div>;
    }
}

const ColWrap = ({ children }) => <div className="page-col-wrap">{children}</div>;

export { ColWrap, Transition };
